import { readsConsultsLeft } from "@/utils/apis/booking-service"
import { ConsultType } from "@/utils/enums/Consults"
import { useAuthStore } from "@/utils/stores/useAuthStore"
import { useConsultsStore } from "@/utils/stores/useConsultsStore"
import { useCallback } from "react"

export const useConsultsLeft = () => {
    const { auth } = useAuthStore()
    const idToken = auth.idToken
    const userId = auth.userId
    const { updateConsultsData } = useConsultsStore()

    const fetchConsultsLeft = useCallback(async () => {
        if (!idToken || !userId) return
        try {
            const [specialist, nutritionist] = await Promise.all([
                readsConsultsLeft(userId, idToken, ConsultType.Specialist),
                readsConsultsLeft(userId, idToken, ConsultType.Nutritionist)
            ])

            const consultsData = {
                specialistConsultsLeft: specialist || 0,
                nutritionistConsultsLeft: nutritionist || 0,
            }

            updateConsultsData(consultsData)
            return consultsData
        } catch (error) {
            console.error("Error fetching consults left:", error)
            const fallbackData = {
                specialistConsultsLeft: 0,
                nutritionistConsultsLeft: 0,
            }
            updateConsultsData(fallbackData)
            return fallbackData
        }
    }, [idToken, updateConsultsData])

    return { fetchConsultsLeft }
}